module.exports = __webpack_public_path__ + "static/media/post-challenge-win-face.97c5d50d.svg";